<template>
    <v-dialog v-model="show" v-bind="$attrs">
        <v-card>
            <v-card-title>
                <slot name="title">
                    Titulo del Modal
                </slot>

                <v-spacer/>

                <v-btn icon @click="$emit('cancel')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <slot></slot>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

    export default {
        name: 'ModalCard',
        props: {
            value: {
                type: Boolean,
                required: false,
            },
        },
        emits: ['input', 'cancel'],
        computed: {
            show: {
                get() {
                    return this.value;
                },
                set(value) {
                    return this.$emit('input', value);
                }
            }
        },
    };

</script>

<style scoped>
</style>